import { Component, OnInit, ViewChild } from '@angular/core';
import { ItemConversa } from 'src/app/models/item-conversa';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { CarregandoService } from 'src/app/services/carregando.service';
import { ItemConversaService } from 'src/app/services/item-conversa.service';
import { Filtro } from 'src/app/models/filtro';
import { MatPaginator, PageEvent, MatDialog, MatDialogRef } from '@angular/material';
import { UtilitarioService } from 'src/app/services/utilitario.service';
import { CadastrarItemConversaModalComponent } from '../cadastrar-item-conversa-modal/cadastrar-item-conversa-modal.component';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { PaginatorService } from 'src/app/services/paginator.service';

// jquery
declare const $: any;
@Component({
  selector: 'app-item-conversa-modal',
  templateUrl: './item-conversa-modal.component.html',
  styleUrls: ['./item-conversa-modal.component.scss']
})
export class ItemConversaModalComponent implements OnInit {
  itensFiltrados: ItemConversa[] = [];
  carregando = true;
  campoOrdenacao = 'descricao';
  ordenarDesc = false;
  editavel = true;
  paginacao;
  listaDeItensPorPagina;
  itensPorPagina;
  filtroNome: Filtro = { Propriedade: 'descri', Valor: '' };
  filtros: Filtro[] = [this.filtroNome];

  @ViewChild('paginator', { static: false }) paginator: MatPaginator;

  public config: PerfectScrollbarConfigInterface = {};

  constructor(
    private notificacaoService: NotificacaoService,
    private carregandoService: CarregandoService,
    private itemConversaService: ItemConversaService,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<ItemConversaModalComponent>,
    private paginatorService: PaginatorService
  ) { }

  ngOnInit(): void {
    const pagination = this.paginatorService.consultarPaginacao();
    
    this.paginacao = pagination.paginacao;
    this.itensPorPagina = pagination.itensPorPagina;
    this.listaDeItensPorPagina = pagination.listaDeItensPorPagina;

    this.buscarItemsConversa();
  }

  ordena(campo) {
    if (campo) {
      this.campoOrdenacao = campo;
      this.ordenarDesc = !this.ordenarDesc;

      this.mudaDePagina({ length: this.paginator.length, pageIndex: this.paginator.pageIndex, pageSize: this.paginator.pageSize });
    }

    return false;
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    if (typeof a === 'string') {
      a = a.toLowerCase();
    }

    if (typeof b === 'string') {
      b = b.toLowerCase();
    }

    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  filtra() {
    this.buscarItemsConversa();
    this.paginator.firstPage();
  }

  mudaDePagina(pageEvent: PageEvent) {
    if (this.itensPorPagina !== pageEvent.pageSize)
      this.paginatorService.salvaPaginacao(pageEvent.pageSize);

    this.itensPorPagina = pageEvent.pageSize;
    this.paginacao.paginaAtual = pageEvent.pageIndex + 1;

    this.buscarItemsConversa();
  }

  salvarItem(item: ItemConversa) {
    this.carregandoService.mostra('salvarItem');

    this.itemConversaService.salvar(item).subscribe(
      () => {
        this.buscarItemsConversa();
        this.carregandoService.esconde('salvarItem');
      },
      err => {
        this.carregandoService.esconde('salvarItem');
        this.notificacaoService.erro(err);

      }
    )
  }

  excluirItem(item: ItemConversa) {
    this.carregandoService.mostra('excluirItem');

    this.itemConversaService.excluir(item.id).subscribe(
      () => {
        this.buscarItemsConversa();
        this.carregandoService.esconde('excluirItem');
      },
      err => {
        this.carregandoService.esconde('excluirItem');
        this.notificacaoService.erro(err);
      }
    )
  }

  buscarItemsConversa() {
    this.carregandoService.mostra('buscarItemsConversa');

    this.itemConversaService.consultarComPaginacao(this.filtroNome.Valor, this.paginacao.paginaAtual, this.itensPorPagina,
      this.campoOrdenacao, this.ordenarDesc ? 'desc' : 'asc').subscribe(
      (dados) => {
        this.itensFiltrados = dados.itens;

        if (this.itensPorPagina > this.listaDeItensPorPagina[this.listaDeItensPorPagina.length - 1]) {
          this.itensPorPagina = 10;
        }

        this.paginacao.total = dados.total;

        this.carregandoService.esconde('buscarItemsConversa');
      }
      , err => {
        this.carregandoService.esconde('buscarItemsConversa');
        this.notificacaoService.erro(err);
      }
    );
  }

  novoItem() {
    const largura = Number(($('body').width()));
    const dialogRef = this.dialog.open(CadastrarItemConversaModalComponent, {
      width: largura > 830 ? '800px' : (($('body').width()).toString() + 'px'),
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((res) => {
      if (!res) return;

      this.salvarItem(res);
    });
  }

  editarItem(item) {
    const largura = Number(($('body').width()));
    const dialogRef = this.dialog.open(CadastrarItemConversaModalComponent, {
      width: largura > 830 ? '800px' : (($('body').width()).toString() + 'px'),
      data: { item },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((res) => {
      if (!res) return;

      this.salvarItem(res);
    });
  }

  fechar() {
    this.dialogRef.close();
  }
}